import React from 'react';
import { Box, Typography, Paper, Divider, List, ListItem, ListItemIcon, ListItemText } from '@mui/material';
import SecurityIcon from '@mui/icons-material/Security';
import HubIcon from '@mui/icons-material/Hub';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';

const CaseStudyCard = () => {
  return (
    <Paper 
      elevation={0} 
      sx={{ 
        p: 4, 
        maxWidth: 800, 
        mx: 'auto', 
        bgcolor: 'background.paper', 
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: 2 
      }}
    >
      <Typography variant="h4" color="primary" gutterBottom>
        Enterprise Network Deployment Prototype
      </Typography>
      <Typography variant="subtitle1" color="text.secondary" sx={{ mb: 4, fontStyle: 'italic' }}>
        A secure, end-to-end network architecture case study.
      </Typography>

      {/* The Challenge */}
      <Box sx={{ mb: 4 }}>
        <Typography variant="h6" color="primary" sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
          <SecurityIcon sx={{ mr: 1 }} /> The Challenge
        </Typography>
        <List dense>
          <ListItem><ListItemText primary="Security Segmentation: Isolating sensitive internal traffic from guest access." /></ListItem>
          <ListItem><ListItemText primary="Traffic Management: Mitigating unauthorized access while ensuring data flow." /></ListItem>
          <ListItem><ListItemText primary="Visibility: Need for centralized logging and automated network control." /></ListItem>
        </List>
      </Box>

      {/* Technical Solution */}
      <Box sx={{ mb: 4 }}>
        <Typography variant="h6" color="primary" sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
          <HubIcon sx={{ mr: 1 }} /> Technical Solution
        </Typography>
        <List dense>
          <ListItem><ListItemText primary="Designed multi-VLAN topology using MikroTik hardware to enforce separation[cite: 1]." /></ListItem>
          <ListItem><ListItemText primary="Implemented custom ACLs and NAT/PAT to manage traffic flow[cite: 1]." /></ListItem>
          <ListItem><ListItemText primary="Engineered SQL-based logging system for rapid audit response[cite: 1]." /></ListItem>
        </List>
      </Box>

      {/* Results */}
      <Box sx={{ mb: 4 }}>
        <Typography variant="h6" color="primary" sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
          <CheckCircleOutlineIcon sx={{ mr: 1 }} /> Results
        </Typography>
        <List dense>
          <ListItem><ListItemText primary="Successfully isolated internal data paths, reducing attack surfaces[cite: 1]." /></ListItem>
          <ListItem><ListItemText primary="Built an automated logging framework for proactive monitoring[cite: 1]." /></ListItem>
          <ListItem><ListItemText primary="Validated design through rigorous testing, demonstrating firewall policy expertise[cite: 1]." /></ListItem>
        </List>
      </Box>

      <Divider sx={{ my: 3 }} />

      <Typography variant="body2" color="text.secondary" sx={{ textAlign: 'center', fontStyle: 'italic' }}>
        Available for a full technical walkthrough during interviews.
      </Typography>
    </Paper>
  );
};

export default CaseStudyCard;